import {
    mdiEmail,
    mdiLogout,
    mdiGift,
    mdiCogOutline
} from "@mdi/js";

import isEmpty from "lodash/isEmpty";
import {  mapActions } from "vuex";

export default {
    computed: {
        navLinks() {
            const { permissions,storePermissions, superUser } = this.$store.state
           
            let links = []
            if (!isEmpty(permissions) && !isEmpty(storePermissions) || superUser) {
                links =  [
                {
                    title: {
                        el: "",
                        en: "",
                        it: ""
                    },
                    children: [
                        {
                            icon: mdiEmail,
                            title: {
                                el: "Αναφορές Δώρων",
                                en: "Gift Reports",
                                it: "Rapporti sui Regali Rivendicati"
                            },
                            to: `/${this.lang}/supplierPanel/send-reports/pending`,
                            exact: true
                        },
                        {
                            icon: mdiGift,
                            title: {
                                el: "Λίστα Δώρων",
                                en: "Gift List",
                                it: "Lista dei Regali"
                            },
                            to: `/${this.lang}/supplierPanel/gifts`
                        },
                        {
                            icon: mdiCogOutline,
                            title: {
                                el: "Στοιχεία Προμηθευτή",
                                en: "Supplier Details",
                                it: "Dettagli del Fornitore"
                            },
                            to: `/${this.lang}/supplierPanel/supplier-data`
                        }
                    ]
                }
            ];
        }
        return links
            
        }
    },
    methods: {
        ...mapActions(["getPermission"]),
        hideTitle(permission){
            return !(this.getPermission(permission))
        }
        
    },
   
};
